export function isNumber(val) {
    return /^[-]?\d+$/.test(val);
}

export function gotNumber(pass) {
    let gotNumberResponse = false;
    pass.split('').some(letter => {
        if(isNumber(letter)) {
            gotNumberResponse = true;
            return true;
        } return false
    });

    return gotNumberResponse;
};

export function gotUpperCaseLetterMin(pass) {
    let passwordNewLower = pass.toLowerCase()
    if(passwordNewLower === pass) return false
    else return true
};

export function gotLowerCaseLetterMin(pass) {
    let passwordNewUpper = pass.toUpperCase()
    if(passwordNewUpper === pass) return false
    else return true
};

export function gotSpecialCharacterMin1(pass) {
    let caracteres = "!$%&/()=¿¡?'_:;,|@#€*+.";
    const filteredArray = pass.split('').filter(letter => caracteres.includes(letter));

    return (filteredArray.length > 0);
}

/*
export function generateP() {
    const str = "ABCDEFGHIJKLMNOPQRSTUVWXYZ" + 
            "abcdefghijklmnopqrstuvwxyz0123456789!$%&/()=¿¡?'_:;,|@#€*+.";   
    let pass = "";
    do{
        pass = "";
        for (let i = 1; i <= 8; i++) {
            var char = Math.floor(Math.random() * str.length + 1);
            pass += str.charAt(char)
        }
    } while(!gotNumber(pass) || !gotUpperCaseLetterMin(pass) || !gotSpecialCharacterMin1(pass) || !gotLowerCaseLetterMin(pass) || pass.length < 8)
      
    return pass;
}
*/

export function generateP(length = 12) {
    const upper = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    const lower = "abcdefghijklmnopqrstuvwxyz";
    const numbers = "0123456789";
    const special = "!$%&/()=¿¡?'_:;,|@#€*+.";
    const allChars = upper + lower + numbers + special;

    const getSecureRandomInt = (max) => {
        const array = new Uint32Array(1);
        window.crypto.getRandomValues(array);
        return array[0] % max;
    };

    const getRandomChar = (charSet) => {
        const randomIndex = getSecureRandomInt(charSet.length);
        return charSet[randomIndex];
    };

    let passwordArray = [
        getRandomChar(upper),
        getRandomChar(lower),
        getRandomChar(numbers),
        getRandomChar(special)
    ];

    for (let i = 0; i < length - 4; i++) {
        passwordArray.push(getRandomChar(allChars));
    }

    for (let i = passwordArray.length - 1; i > 0; i--) {
        const j = getSecureRandomInt(i + 1);
        [passwordArray[i], passwordArray[j]] = [passwordArray[j], passwordArray[i]];
    }

    return passwordArray.join('');
}